import React from "react";
import {Row} from "react-bootstrap";

class Pause extends React.Component{
    state = {
        pause:true
    }
    
    toggleButton = ()=>{
        this.setState({
            pause:!this.state.pause
        })
    }

    render(){
        const dot = {
            background: "green",
            width: "7px",
            height: "7px",
            borderRadius: "100px",
        }
       return (
        <div className="d-flex row justify-content-between mb-2 m-1">
        <div className="align-items-start">
            <Row className="align-items-center">
                <div style={dot} className="ml-3 mr-1" /> <p className="text-muted" style={{ fontSize: "12px", fontWeight:"400",margin: 0 }}>{this.props.completiontime}</p>
            </Row>
            <strong onClick={()=>{
                this.props.history.push(`/edit/${this.props.index}`)
            }
            } className="strong" style={{ fontSize: "14px",fontWeight:"500", padding: 0, }}>{this.props.tracktername}</strong>
            <p className="text-muted" style={{ fontSize: "12px",fontWeight:"400", margin: 0 }}>{this.props.status}</p>
        </div>
        <div style={{
            className: "d-flex justify-content-center align-items-center",
            width: "65px",
            height: "65px",
            border: `2px ${!this.state.pause?'#e6f9f0':'#CED2DA'} solid`,
            borderRadius: "2000px",
            background: "white",
            textAlign: "center"
        }}>
        {!this.state.pause?
      <div onClick={()=>{
        this.toggleButton()
    }} className="text-center" style={{ marginTop: "calc(50% - 10px)" }}>0%</div>:
      <i onClick={()=>{
        this.toggleButton()
    }} className={`${this.state.pause?'fas fa-play':'fas fa-pause'} text-dark`} style={{ marginTop: "calc(50% - 8px)" }} aria-hidden="true"></i>

    }    
       
        </div>
    </div>
       )
    }
}

export default Pause;

